import Accordion from 'accordion-js';

const accordion = new Accordion('.accordion-container', {
  duration: 500,
  openOnInit: [0],
});
